import BaseView from "scripts/views/baseView";
import styles from "./Footer.css";
import template from "./Footer.hbs";

class Footer extends BaseView {
  constructor(props) {
    super();

    this.template = () =>
      template({
        styles,
        ...props,
      });
  }

  render() {
    this.$el.html(this.template());
    return this;
  }
}

export default Footer;
